import connect from 'react-redux/es/connect/connect';

import ActivityTimeslotsPage from '../components/admin/ActivityTimeslotsPage';

const mapStateToProps = state => ({
    user: state.user.user
});

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(ActivityTimeslotsPage);
